import {
  differenceInHours,
  differenceInMinutes,
  isSameDay,
  isSameMonth,
  isSameYear,
} from 'date-fns'
import fmt from '@/functions/fmt/date'

export default {
  rangeHour: (start: string, end: string) => {
    // calculate start and end (HH:mm) into values like 9j 45m

    if (!start || !end) return ''

    const checkin = new Date('2000-01-01 ' + start)
    const checkout = new Date('2000-01-01 ' + end)

    const differenceHours = differenceInHours(checkout, checkin)
    const differenceMinutes = differenceInMinutes(checkout, checkin) % 60

    return `${differenceHours}j ${differenceMinutes}m`
  },
  rangeDate: (start: string | Date, end: string | Date) => {
    // Same day => 30 Jun 2021
    // Same month => 1 - 30 Jun 2021
    // Different month same year => 1 Mar - 15 Mei 2021
    // Different year => 15 Des 2021 - 15 Jan 2022

    let formatStart = ''
    const formatEnd = 'd MMM yyyy'
    if (isSameDay(start, end)) {
      return fmt.date(start, formatEnd)
    }

    if (!isSameYear(start, end)) {
      formatStart = formatEnd
    } else if (!isSameMonth(start, end)) {
      formatStart = 'd MMM'
    } else {
      formatStart = 'd'
    }

    return fmt.date(start, formatStart) + ' - ' + fmt.date(end, formatEnd)
  },
}
